import React, { useEffect, useRef, useState } from 'react';
import { ImagePlus, X, Loader2, Film } from 'lucide-react';
import {
  MONTHS, compactRound as cr, moneyFull, intFull, change, pageLabel, RichText, TextField, NumberField,
} from './bulletinShared';

// Aylık bülten — "karma" şablon (3 sayfa, 16:9).
// İçerik: Enza PDF bülteni + Yataş Bedding PPTX taslağının birleşimi.
//   01 Ay nasıl geçti?   — 4 ana KPI (önceki ay + HEDEF gerçekleşme + 6 aylık trend), ikincil
//                          metrikler, Performans / Branding kutuları + yorum cümlesi
//   02 Ayın kampanyası   — video + 2 kreatif (elle), gösterim/izlenme/tamamlanma, özet; öne çıkan ürünler GÖRSELLİ (Merchant Center)
//   03 Gelecek ay        — gerçekleşen → hedef + bütçe dağılımı + kampanya/mecra
// Tasarım: Glowytics'in apple.com dilindeki sunum şablonu (src/pages/_deck-sablon): beyaz slayt,
// #f5f5f7 yuvarlak kutular, sıkı harf aralıklı büyük rakam, InterDisplay, Glowytics mavisi.
// Her slaytın başlığı veriden otomatik yazılır, "Düzenle" ile değiştirilebilir (manual.mix.*).
// Elle alanlar diğer iki şablonla aynı anahtarları kullanır.

const W = 1280;
const H = 720;
const C = {
  ink: '#1d1d1f', ink2: '#6e6e73', ink3: '#86868b', hair: '#e0e0e3', tile: '#f5f5f7',
  brand: '#0a5bd3', blue: '#0071e3', green: '#28b463', amber: '#ff9f0a', pink: '#ff375f',
  up: '#1a9e56', down: '#e11d48',
};
const TINT = {
  brand: 'linear-gradient(150deg,#e9f1fd 0%,#d4e3fb 100%)',
  green: 'linear-gradient(150deg,#e8f8ee 0%,#dbf2e4 100%)',
  amber: 'linear-gradient(150deg,#fff4e0 0%,#ffecca 100%)',
};

// "Temmuz'a göre", "Ağustos'ta" — ünlü/ünsüz uyumuna göre ekler
const DATIVE = ['Ocak\'a', 'Şubat\'a', 'Mart\'a', 'Nisan\'a', 'Mayıs\'a', 'Haziran\'a', 'Temmuz\'a', 'Ağustos\'a', 'Eylül\'e', 'Ekim\'e', 'Kasım\'a', 'Aralık\'a'];
const LOCATIVE = ['Ocak\'ta', 'Şubat\'ta', 'Mart\'ta', 'Nisan\'da', 'Mayıs\'ta', 'Haziran\'da', 'Temmuz\'da', 'Ağustos\'ta', 'Eylül\'de', 'Ekim\'de', 'Kasım\'da', 'Aralık\'ta'];

const money = (v) => (v == null || !isFinite(v) ? '–' : `₺${cr(v)}`);
const num = (v) => (v == null || !isFinite(v) ? '–' : cr(v));
const dur = (s) => (s == null || !isFinite(s) ? '–' : `${Math.floor(s / 60)}:${String(Math.round(s % 60)).padStart(2, '0')}`);
const pct = (v, d = 0) => (v == null || !isFinite(v) ? '–' : `%${v.toFixed(d).replace('.', ',')}`);
const roasFmt = (v) => (v == null || !isFinite(v) || !v ? '–' : v.toFixed(1).replace('.', ','));

const CSS = `
@font-face{font-family:'InterDisplay';src:url('/fonts/InterDisplay-Medium.woff2') format('woff2');font-weight:500;font-display:swap}
@font-face{font-family:'InterDisplay';src:url('/fonts/InterDisplay-SemiBold.woff2') format('woff2');font-weight:600;font-display:swap}
.bm-slide{position:relative;width:${W}px;height:${H}px;background:#fff;overflow:hidden;border-radius:18px;
  box-shadow:0 1px 2px rgba(0,0,0,.05),0 10px 30px rgba(0,0,0,.06);color:${C.ink};
  font-family:'InterDisplay',-apple-system,BlinkMacSystemFont,'SF Pro Display','Segoe UI',Roboto,sans-serif;
  font-weight:500;-webkit-font-smoothing:antialiased;font-variant-numeric:tabular-nums;letter-spacing:-.012em}
.bm-head{position:absolute;left:56px;right:56px;top:44px}
.bm-eye{font-size:12.5px;font-weight:600;color:${C.brand};margin-bottom:8px}
.bm-h1{font-size:38px;line-height:1.08;font-weight:600;letter-spacing:-.028em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:1000px}
.bm-lead{margin-top:8px;font-size:15.5px;line-height:1.42;color:${C.ink2};letter-spacing:-.01em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:1060px}
.bm-lead b{color:${C.ink};font-weight:600}
.bm-no{position:absolute;top:46px;right:56px;font-size:10px;letter-spacing:.06em;color:${C.ink3}}
.bm-body{position:absolute;left:56px;right:56px;top:160px;bottom:60px}
.bm-tile{background:${C.tile};border-radius:20px;padding:18px 20px;position:relative;overflow:hidden;display:flex;flex-direction:column;min-height:0}
.bm-tile.white{background:#fff;border:1px solid ${C.hair}}
.bm-lbl{font-size:12px;font-weight:600;color:${C.ink3}}
.bm-num{font-weight:600;letter-spacing:-.036em;line-height:1;white-space:nowrap}
.bm-cap{font-size:12.5px;line-height:1.38;color:${C.ink2};letter-spacing:-.006em}
.bm-txt{font-size:13.5px;line-height:1.45;color:${C.ink2};letter-spacing:-.006em}
.bm-txt b{color:${C.ink};font-weight:600}
.bm-chip{font-size:12.5px;font-weight:500;color:${C.ink2};background:#fff;border:1px solid ${C.hair};border-radius:100px;padding:5px 12px;white-space:nowrap}
.bm-foot{position:absolute;left:56px;right:56px;bottom:20px;height:24px;display:flex;align-items:center;justify-content:space-between}
.bm-foot .rail{font-size:9.5px;letter-spacing:.08em;color:${C.ink3};display:flex;gap:9px;align-items:center}
.bm-foot .rail i{width:3px;height:3px;border-radius:50%;background:#c9c9ce;display:inline-block}
`;

function Scaled({ children }) {
  const ref = useRef(null);
  const [scale, setScale] = useState(1);
  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const ro = new ResizeObserver(([e]) => setScale(Math.min(1, e.contentRect.width / W)));
    ro.observe(el);
    return () => ro.disconnect();
  }, []);
  return (
    <div ref={ref} className="bt-slide-wrap" style={{ width: '100%', height: H * scale, position: 'relative' }}>
      <div className="bt-slide" style={{ width: W, height: H, transform: `scale(${scale})`, transformOrigin: 'top left', position: 'absolute', left: 0, top: 0 }}>
        {children}
      </div>
    </div>
  );
}

function Delta({ ch, lowerIsBetter, label, size = 12.5 }) {
  if (ch == null || !isFinite(ch)) return <span style={{ fontSize: size, color: C.ink3 }}>–</span>;
  const up = ch >= 0;
  const good = lowerIsBetter ? !up : up;
  const v = Math.abs(ch);
  return (
    <span style={{ fontSize: size, fontWeight: 600, color: good ? C.up : C.down, whiteSpace: 'nowrap' }}>
      {up ? '↑' : '↓'} %{v < 10 ? v.toFixed(1).replace('.', ',') : Math.round(v)}
      {label && <span style={{ color: C.ink3, fontWeight: 500 }}> {label}</span>}
    </span>
  );
}

// 6 aylık çizgi — son nokta vurgulu, altında ay baş harfleri
function Spark({ values, labels, color, w, h = 38 }) {
  const vals = values.map((x) => (x == null || !isFinite(x) ? null : x));
  const ok = vals.filter((x) => x != null);
  if (ok.length < 2) return <div style={{ height: h + 16 }} />;
  const min = Math.min(...ok); const max = Math.max(...ok);
  const span = max - min || 1;
  const step = w / (vals.length - 1);
  const pts = vals.map((x, i) => (x == null ? null : [i * step, 5 + (h - 10) * (1 - (x - min) / span)]));
  const line = pts.filter(Boolean).map((p) => p.join(',')).join(' ');
  const last = pts[pts.length - 1];
  const gid = `bmsg${color.replace('#', '')}`;
  return (
    <div>
      <svg width={w} height={h} style={{ display: 'block', overflow: 'visible' }}>
        <defs>
          <linearGradient id={gid} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor={color} stopOpacity="0.16" /><stop offset="100%" stopColor={color} stopOpacity="0" />
          </linearGradient>
        </defs>
        <polygon points={`0,${h} ${line} ${w},${h}`} fill={`url(#${gid})`} />
        <polyline points={line} fill="none" stroke={color} strokeWidth="2" strokeLinejoin="round" strokeLinecap="round" />
        {last && <circle cx={last[0]} cy={last[1]} r="3.6" fill="#fff" stroke={color} strokeWidth="2.2" />}
      </svg>
      <div style={{ display: 'flex', justifyContent: 'space-between', width: w + 8, marginLeft: -4, marginTop: 4 }}>
        {labels.map((l, i) => (
          <span key={i} style={{ fontSize: 9.5, width: 14, textAlign: 'center', color: i === labels.length - 1 ? C.ink : C.ink3, fontWeight: i === labels.length - 1 ? 600 : 500 }}>{l}</span>
        ))}
      </div>
    </div>
  );
}

function Progress({ actual, target, color, label, fmt }) {
  if (target == null || !target || actual == null) {
    return <div className="bm-cap" style={{ color: C.ink3, height: 26 }}>{label} girilmemiş</div>;
  }
  const p = (actual / target) * 100;
  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, color: C.ink2, marginBottom: 6 }}>
        <span>{label} {fmt(target)}</span>
        <span style={{ color: p >= 100 ? C.up : C.ink, fontWeight: 600 }}>{pct(p)}</span>
      </div>
      <div style={{ height: 5, borderRadius: 3, background: 'rgba(0,0,0,0.07)', overflow: 'hidden' }}>
        <div style={{ width: `${Math.min(100, p)}%`, height: '100%', borderRadius: 3, background: color }} />
      </div>
    </div>
  );
}

function Slide({ eyebrow, title, lead, no, theme, children }) {
  return (
    <div className="bm-slide">
      <div className="bm-head">
        <div className="bm-eye">{eyebrow}</div>
        <div className="bm-h1">{title}</div>
        {lead && <div className="bm-lead"><RichText text={lead} /></div>}
      </div>
      <div className="bm-no">{no}</div>
      <div className="bm-body">{children}</div>
      <div className="bm-foot">
        {theme.logoDark
          ? <img src={theme.logoDark} alt={theme.name} style={{ height: 18, width: 'auto', opacity: 0.85 }} />
          : <span style={{ fontSize: 12, fontWeight: 600, color: C.ink2 }}>{theme.name}</span>}
        <div className="rail"><span>DİJİTAL PAZARLAMA</span><i /><span>AYLIK BÜLTEN</span></div>
        <img src="/Calisma-Yuzeyi-20@5x-4.png" alt="Glowytics" style={{ height: 18, width: 'auto', opacity: 0.8 }} />
      </div>
    </div>
  );
}

const panel = 'bt-noprint mt-3 mb-8 bg-amber-50 border border-amber-200 rounded-xl p-4 grid gap-3 md:grid-cols-2 text-sm';
const lbl = 'block text-xs font-semibold text-amber-900 mb-1';

export default function BulletinMix({ data, manual, set, editing, year, month, theme, pickImage, removeImage, uploading }) {
  const a = data.auto;
  const cur = a.current;
  const prev = a.previous;
  const ov = manual.overrides || {};
  const mx = manual.mix || {};
  const pick = (k) => (ov[k] != null ? ov[k] : cur[k]);
  const T = a.targets || {};

  const monthName = MONTHS[month - 1];
  const nextName = MONTHS[month % 12];
  const nextYear = month === 12 ? year + 1 : year;
  const monthLabel = `${monthName} ${year}`;
  const vsPrev = `${DATIVE[(month + 10) % 12]} göre`;

  const v = {
    revenue: pick('revenue'), sessions: pick('sessions'), users: pick('users'), cost: pick('cost'),
    impressions: pick('impressions'), views: pick('views'), bounce: pick('bounceRate'),
    costPerformance: pick('costPerformance'), costBranding: pick('costBranding'),
    sessionsPerformance: pick('sessionsPerformance'), sessionsBranding: pick('sessionsBranding'),
    revenuePerformance: pick('revenuePerformance'), revenueBranding: pick('revenueBranding'),
    impressionsBranding: pick('impressionsBranding'), viewsBranding: pick('viewsBranding'),
    duration: ov.avgSessionDuration ?? a.avgSessionDuration,
    directions: ov.directions ?? a.directions?.current,
  };
  v.roas = v.costPerformance > 0 ? v.revenue / v.costPerformance : cur.roas;
  const prevRoas = prev.costPerformance > 0 ? prev.revenue / prev.costPerformance : prev.roas;

  const trend = a.trend || [];
  const tl = trend.map((t) => MONTHS[t.month - 1].slice(0, 1));
  const tv = (k) => trend.map((t, i) => (i === trend.length - 1 && ov[k] != null ? ov[k] : t[k]));

  // E-ticareti olmayan marka (Divanev): 6 ayda hiç ciro yoksa ciro/ROAS/ürün yerine gösterim/izlenme/maliyet
  const noShop = !(v.revenue > 0) && !trend.some((t) => t.revenue > 0);
  const cpm = (c, i) => (i > 0 ? (c / i) * 1000 : null);
  const tl3 = (x) => (x == null || !isFinite(x) ? '–' : `₺${x.toFixed(1).replace('.', ',')}`);
  const heroShop = [
    { k: 'revenue', label: 'Toplam ciro', value: money(v.revenue), ch: change(v.revenue, prev.revenue),
      target: T.revenue, tLabel: 'Hedef', fmt: money, color: C.green, spark: tv('revenue') },
    { k: 'sessions', label: 'Web trafiği', value: num(v.sessions), ch: change(v.sessions, prev.sessions),
      target: T.sessions, tLabel: 'Hedef', fmt: num, color: C.blue, spark: tv('sessions') },
    { k: 'cost', label: 'Reklam harcaması', value: money(v.cost), ch: change(v.cost, prev.cost),
      target: T.cost, tLabel: 'Bütçe', fmt: money, color: C.amber, spark: tv('cost') },
    { k: 'roas', label: 'ROAS', value: roasFmt(v.roas), ch: change(v.roas, prevRoas),
      target: T.roas, tLabel: 'Hedef', fmt: roasFmt, color: C.brand, spark: trend.map((t, i) => (i === trend.length - 1 ? v.roas : t.roas)) },
  ];
  const hero = noShop ? [
    { k: 'impressions', label: 'Reklam gösterimi', value: num(v.impressions), ch: change(v.impressions, prev.impressions),
      target: T.impressions, tLabel: 'Hedef', fmt: num, color: C.brand, spark: tv('impressions') },
    heroShop[1],
    heroShop[2],
    { k: 'views', label: 'Video izlenme', value: num(v.views), ch: change(v.views, prev.views),
      target: T.views, tLabel: 'Hedef', fmt: num, color: C.pink, spark: tv('views') },
  ] : heroShop;

  const strip = [
    ['Tekil kullanıcı', num(v.users), change(v.users, prev.users)],
    ...(noShop ? [
      ['Bin gösterim maliyeti', tl3(cpm(v.cost, v.impressions)), change(cpm(v.cost, v.impressions), cpm(prev.cost, prev.impressions)), true],
      ['Ziyaret başı maliyet', tl3(v.sessions > 0 ? v.cost / v.sessions : null), change(v.sessions > 0 ? v.cost / v.sessions : null, prev.sessions > 0 ? prev.cost / prev.sessions : null), true],
    ] : [
      ['Reklam gösterimi', num(v.impressions), change(v.impressions, prev.impressions)],
      ['Video izlenme', num(v.views), change(v.views, prev.views)],
    ]),
    ['Yol tarifi', v.directions != null ? intFull(v.directions) : '–', change(v.directions, a.directions?.previous)],
    ['Sitede kalma', dur(v.duration), change(v.duration, a.avgSessionDurationPrev)],
    ['Hemen çıkma', pct(v.bounce, 1), change(v.bounce, prev.bounceRate), true],
  ];

  // Otomatik başlık: ciro hedefe göre (hedef yoksa ya da açıkça hatalıysa önceki aya göre)
  const revVsT = T.revenue ? ((v.revenue - T.revenue) / T.revenue) * 100 : null;
  const revCh = change(v.revenue, prev.revenue);
  const sessCh = change(v.sessions, prev.sessions);
  const sessVsT = T.sessions ? ((v.sessions - T.sessions) / T.sessions) * 100 : null;
  const autoH1 = noShop
    ? (sessVsT != null && Math.abs(sessVsT) < 200
      ? `${LOCATIVE[month - 1]} trafik hedefin %${Math.abs(Math.round(sessVsT))} ${sessVsT >= 0 ? 'üzerinde' : 'altında'} kapandı`
      : `${LOCATIVE[month - 1]} sitemize ${num(v.sessions)} ziyaret geldi`)
    : revVsT != null && Math.abs(revVsT) < 200
    ? `${LOCATIVE[month - 1]} ciro hedefin %${Math.abs(Math.round(revVsT))} ${revVsT >= 0 ? 'üzerinde' : 'altında'} kapandı`
    : `${LOCATIVE[month - 1]} ciro ${money(v.revenue)} oldu`;
  const autoLead = noShop
    ? `Trafik **${num(v.sessions)}** ziyaret${sessCh != null ? ` (${vsPrev} ${sessCh >= 0 ? '+' : '−'}%${Math.abs(Math.round(sessCh))})` : ''}; **${money(v.cost)}** reklam harcamasıyla **${num(v.impressions)}** gösterim ve **${num(v.views)}** izlenme.`
    : `Ciro **${money(v.revenue)}**${revCh != null ? ` (${vsPrev} ${revCh >= 0 ? '+' : '−'}%${Math.abs(Math.round(revCh))})` : ''}, trafik **${num(v.sessions)}** ziyaret, `
    + `**${money(v.cost)}** reklam harcamasıyla ROAS **${roasFmt(v.roas)}**.`;

  const perfShare = v.cost > 0 ? (v.costPerformance / v.cost) * 100 : null;
  const brandShare = v.cost > 0 ? (v.costBranding / v.cost) * 100 : null;
  const autoPerf = `**${money(v.costPerformance)}** performans bütçesiyle **${money(v.revenuePerformance)}** ciro getiren **${num(v.sessionsPerformance)}** ziyaret sağlandı.`;
  const autoBrand = `**${money(v.costBranding)}** branding bütçesiyle **${num(v.impressionsBranding)}** gösterim ve **${num(v.viewsBranding)}** izlenme sağlandı; site trafiği ${vsPrev} **%${Math.abs(Math.round(sessCh || 0))}** ${sessCh >= 0 ? 'arttı' : 'azaldı'}.`;

  // Sayfa 2
  const camp = manual.campaign || {};
  const images = camp.images || [null, null, null];
  const cs = camp.stats || {};
  const keyword = (camp.videoKeyword || '').trim();
  const campImpr = cs.impressions ?? (keyword ? a.video?.impressions : v.impressionsBranding);
  const campViews = cs.views ?? (keyword ? a.video?.views : v.viewsBranding);
  const campRate = cs.completion ?? a.video?.completionRate;
  const lastDay = new Date(year, month, 0).getDate();
  const campSummary = camp.summary || (camp.title
    ? `**1-${lastDay} ${monthName}** tarihleri arasında yayınlanan **"${camp.title}"** kampanyamız ile geniş bir kitleye ulaşıldı; toplam **${num(campViews)}** izlenme ve **${num(campImpr)}** gösterim gerçekleşti${campRate != null ? `, videoların tamamlanma oranı **${pct(campRate)}** oldu` : ''}.`
    : '');
  // Video alanı: YouTube linki ya da yüklenen video dosyası
  const video = (() => {
    const u = String(camp.video || '').trim();
    if (!u) return {};
    const yt = /(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/)|youtu\.be\/)([\w-]{11})/.exec(u);
    if (yt) return { kind: 'youtube', href: u, thumb: `https://i.ytimg.com/vi/${yt[1]}/hqdefault.jpg` };
    return { kind: 'file', src: u };
  })();
  const hl = manual.highlights || {};
  const channels = a.channels || [];
  const channel = channels.find((c) => c.label === hl.channel) || channels[0];
  const productOpts = a.products || [];
  const productNames = hl.products && hl.products.length ? hl.products : productOpts.slice(0, 6).map((p) => p.name);
  const products = productNames.slice(0, 6).map((nm) => productOpts.find((p) => p.name === nm) || { name: nm });
  const pageOpts = a.pages || [];
  // Ürün yoksa (e-ticaretsiz marka) sağ sütunun tamamı sayfalara kalır
  const pageCount = products.length ? 3 : 8;
  const pages = hl.pages && hl.pages.length >= pageCount ? hl.pages : [...(hl.pages || []), ...pageOpts.filter((p) => !(hl.pages || []).some((x) => x.path === p.path)).map((p) => ({ path: p.path, label: pageLabel(p) }))].slice(0, pageCount);
  const pageViews = (path) => pageOpts.find((p) => p.path === path)?.views;
  const autoLead2 = channel
    ? `En çok trafik **${channel.label}** üzerinden geldi: **${num(channel.sessions)}** ziyaret, toplam trafiğin **${pct(v.sessions ? (channel.sessions / v.sessions) * 100 : null)}** kadarı.`
    : '';

  // Sayfa 3
  const nx = manual.next || {};
  const nt = a.nextTargets || {};
  const tgt = (k) => (nx.targets?.[k] != null ? nx.targets[k] : nt[k]);
  const budgetPerf = tgt('costPerformance') || 0;
  const budgetBrand = tgt('costBranding') || 0;
  const budgetTotal = budgetPerf + budgetBrand;
  const campaigns = String(nx.campaigns || '').split('\n').map((x) => x.trim()).filter(Boolean);
  const chips = String(nx.channels || (a.activeChannels || []).join(', ')).split(',').map((x) => x.trim()).filter(Boolean);
  const plan = [
    !noShop && ['Ciro', v.revenue, tgt('revenue'), money, C.green],
    ['Web trafiği', v.sessions, tgt('sessions'), num, C.blue],
    ['Reklam gösterimi', v.impressions, tgt('impressions'), num, C.brand],
    ['Video izlenme', v.views, tgt('views'), num, C.pink],
    ['Toplam bütçe', v.cost, budgetTotal || null, money, C.amber],
  ].filter(Boolean);
  const nextRevCh = tgt('revenue') && v.revenue ? change(tgt('revenue'), v.revenue) : null;
  const autoH3 = !noShop && tgt('revenue') ? `${nextName} hedefi ${money(tgt('revenue'))} ciro` : `${nextName} ${nextYear} planı`;
  const autoLead3 = [
    nextRevCh != null && `${DATIVE[month - 1]} göre **${nextRevCh >= 0 ? '+' : '−'}%${Math.abs(Math.round(nextRevCh))}**`,
    budgetTotal && `**${money(budgetTotal)}** toplam bütçe`,
    campaigns[0] && `ana kampanya **${campaigns[0]}**`,
  ].filter(Boolean).join(' · ');

  return (
    <div className="space-y-6">
      <style>{CSS}</style>

      {/* ── 01 · AY NASIL GEÇTİ ── */}
      <div className="bt-section">
        <Scaled>
          <Slide theme={theme} no="1 / 3" eyebrow={`${monthLabel} · Ay nasıl geçti?`} title={mx.h1 || autoH1} lead={mx.lead1 || autoLead}>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 12, height: 226 }}>
              {hero.map((k) => (
                <div key={k.k} className="bm-tile">
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
                    <span className="bm-lbl">{k.label}</span>
                    <Delta ch={k.ch} size={12} />
                  </div>
                  <div className="bm-num" style={{ fontSize: 46, marginTop: 10 }}>{k.value}</div>
                  <div style={{ marginTop: 14 }}>
                    <Progress actual={k.k === 'roas' ? v.roas : v[k.k]} target={k.target} color={k.color} label={k.tLabel} fmt={k.fmt} />
                  </div>
                  <div style={{ marginTop: 'auto' }}>
                    <Spark values={k.spark} labels={tl} color={k.color} w={232} h={34} />
                  </div>
                </div>
              ))}
            </div>

            <div className="bm-tile white" style={{ marginTop: 12, height: 70, padding: 0, display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)' }}>
              {strip.map(([l, val, ch, lower], i) => (
                <div key={l} style={{ padding: '12px 18px', borderLeft: i ? `1px solid ${C.hair}` : 'none' }}>
                  <div className="bm-lbl" style={{ fontSize: 11.5 }}>{l}</div>
                  <div style={{ display: 'flex', alignItems: 'baseline', gap: 8, marginTop: 5 }}>
                    <span className="bm-num" style={{ fontSize: 22, letterSpacing: '-.02em' }}>{val}</span>
                    <Delta ch={ch} lowerIsBetter={lower} size={11} />
                  </div>
                </div>
              ))}
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: data.allBranding ? '1fr' : '1fr 1fr', gap: 12, marginTop: 12, height: 180 }}>
              {[
                !data.allBranding && {
                  key: 'perf', title: 'Satış reklamları', tag: 'Performans', color: C.brand, tint: TINT.brand, share: perfShare,
                  text: manual.perfText || autoPerf,
                  metrics: [
                    ['Harcama', money(v.costPerformance), change(v.costPerformance, prev.costPerformance)],
                    ['Trafik', num(v.sessionsPerformance), change(v.sessionsPerformance, prev.sessionsPerformance)],
                    ['Ciro', money(v.revenuePerformance), change(v.revenuePerformance, prev.revenuePerformance)],
                    ['Ciro / harcama', roasFmt(v.costPerformance > 0 ? v.revenuePerformance / v.costPerformance : null), change(v.costPerformance > 0 ? v.revenuePerformance / v.costPerformance : null, prev.costPerformance > 0 ? prev.revenuePerformance / prev.costPerformance : null)],
                  ],
                },
                {
                  key: 'brand', title: 'Tanıtım reklamları', tag: 'Branding', color: C.up, tint: TINT.green, share: brandShare,
                  text: manual.brandText || autoBrand,
                  metrics: [
                    ['Harcama', money(v.costBranding), change(v.costBranding, prev.costBranding)],
                    ['Gösterim', num(v.impressionsBranding), change(v.impressionsBranding, prev.impressionsBranding)],
                    ['İzlenme', num(v.viewsBranding), change(v.viewsBranding, prev.viewsBranding)],
                    v.sessionsBranding > 0
                      ? ['Trafik', num(v.sessionsBranding), change(v.sessionsBranding, prev.sessionsBranding)]
                      : ['Bin gösterim maliyeti', tl3(cpm(v.costBranding, v.impressionsBranding)), change(cpm(v.costBranding, v.impressionsBranding), cpm(prev.costBranding, prev.impressionsBranding))],
                  ],
                },
              ].filter(Boolean).map((b) => (
                <div key={b.key} className="bm-tile" style={{ background: b.tint, padding: '16px 20px' }}>
                  <div style={{ display: 'flex', alignItems: 'baseline', gap: 10 }}>
                    <span style={{ fontSize: 17, fontWeight: 600, letterSpacing: '-.02em' }}>{b.title}</span>
                    <span style={{ fontSize: 12, fontWeight: 600, color: b.color }}>{b.tag}</span>
                    {b.share != null && <span className="bm-cap" style={{ marginLeft: 'auto' }}>Bütçe payı <b style={{ color: C.ink, fontWeight: 600 }}>{pct(b.share)}</b></span>}
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 8, marginTop: 12 }}>
                    {b.metrics.map(([l, val, ch]) => (
                      <div key={l} style={{ background: 'rgba(255,255,255,0.72)', borderRadius: 12, padding: '9px 12px' }}>
                        <div className="bm-cap" style={{ fontSize: 11.5 }}>{l}</div>
                        <div className="bm-num" style={{ fontSize: 22, letterSpacing: '-.025em', marginTop: 4 }}>{val}</div>
                        <div style={{ marginTop: 3 }}><Delta ch={ch} size={11} /></div>
                      </div>
                    ))}
                  </div>
                  <div className="bm-txt" style={{ marginTop: 'auto', fontSize: 13, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}><RichText text={b.text} /></div>
                </div>
              ))}
            </div>
          </Slide>
        </Scaled>
        {editing && (
          <div className={panel}>
            <div className="md:col-span-2 font-semibold text-amber-900">Sayfa 1 — başlık, yorumlar ve elle düzeltmeler</div>
            <div>
              <label className={lbl}>Başlık (boşsa otomatik)</label>
              <TextField editing value={mx.h1} onChange={(x) => set('mix.h1', x)} placeholder={autoH1} />
            </div>
            <div>
              <label className={lbl}>Alt satır (boşsa otomatik · **kalın** yazılabilir)</label>
              <TextField editing value={mx.lead1} onChange={(x) => set('mix.lead1', x)} placeholder={autoLead.replace(/\*\*/g, '')} />
            </div>
            <div>
              <label className={lbl}>Satış reklamları yorumu (boşsa otomatik)</label>
              <TextField editing multiline rows={2} value={manual.perfText} onChange={(x) => set('perfText', x)} placeholder={autoPerf.replace(/\*\*/g, '')} />
            </div>
            <div>
              <label className={lbl}>Tanıtım reklamları yorumu (boşsa otomatik)</label>
              <TextField editing multiline rows={2} value={manual.brandText} onChange={(x) => set('brandText', x)} placeholder={autoBrand.replace(/\*\*/g, '')} />
            </div>
            <div className="md:col-span-2">
              <label className={lbl}>Sayıyı elle düzelt (boşsa otomatik)</label>
              <div className="grid grid-cols-3 md:grid-cols-6 gap-2">
                {[['revenue', 'Ciro'], ['sessions', 'Trafik'], ['cost', 'Harcama'], ['users', 'Kullanıcı'], ['impressions', 'Gösterim'], ['views', 'İzlenme'],
                  ['directions', 'Yol tarifi'], ['avgSessionDuration', 'Kalma süresi (sn)'], ['bounceRate', 'Hemen çıkma %'],
                  ['costPerformance', 'Performans harcama'], ['costBranding', 'Branding harcama'], ['revenuePerformance', 'Performans ciro']].map(([k, l]) => (
                  <div key={k}><label className="block text-[11px] text-amber-900 mb-0.5">{l}</label>
                    <NumberField editing value={ov[k]} onChange={(x) => set(`overrides.${k}`, x)} placeholder="oto" /></div>
                ))}
              </div>
              <div className="text-xs text-amber-800 mt-2">Hedefler “Target vs Actual” sayfasındaki {monthName} hedeflerinden gelir.</div>
            </div>
          </div>
        )}
      </div>

      {/* ── 02 · AYIN KAMPANYASI ── */}
      <div className="bt-section">
        <Scaled>
          <Slide theme={theme} no="2 / 3" eyebrow={camp.tagline || `${monthLabel} · Ayın kampanyası`}
            title={camp.title || 'Ayın kampanyası'} lead={mx.lead2 || autoLead2}>
            <div style={{ display: 'grid', gridTemplateColumns: '1.62fr 1fr', gap: 12, height: '100%' }}>
              {/* Sol: 2 kreatif + video (elle) · altında kampanya sayıları · en altta özet */}
              <div style={{ display: 'grid', gridTemplateRows: '1fr 96px auto', gap: 12, minHeight: 0 }}>
                <div style={{ display: 'grid', gridTemplateColumns: '1.5fr 1fr', gridTemplateRows: '1fr 1fr', gap: 12, minHeight: 0 }}>
                  <div style={{ gridRow: '1 / 3', borderRadius: 20, overflow: 'hidden', background: '#111', position: 'relative' }}>
                    {video.kind === 'file' && <video src={video.src} controls preload="metadata" playsInline style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />}
                    {video.kind === 'youtube' && (
                      <a href={video.href} target="_blank" rel="noreferrer" style={{ display: 'block', width: '100%', height: '100%', position: 'relative' }}>
                        <img src={video.thumb} alt="" referrerPolicy="no-referrer" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
                        <span style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%,-50%)', width: 64, height: 64, borderRadius: 32, background: 'rgba(0,0,0,.55)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <span style={{ width: 0, height: 0, borderTop: '12px solid transparent', borderBottom: '12px solid transparent', borderLeft: '20px solid #fff', marginLeft: 5 }} />
                        </span>
                      </a>
                    )}
                    {!video.kind && <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#8e8e93', fontSize: 12.5, background: C.tile }}>Video</div>}
                    {video.kind && <span style={{ position: 'absolute', left: 12, top: 12, fontSize: 10.5, fontWeight: 600, letterSpacing: '.06em', color: '#fff', background: 'rgba(0,0,0,.45)', borderRadius: 999, padding: '3px 9px', pointerEvents: 'none' }}>VİDEO</span>}
                    {editing && (
                      <div className="bt-noprint" style={{ position: 'absolute', right: 10, top: 10, display: 'flex', gap: 6 }}>
                        <button type="button" onClick={() => pickImage('video')} className="bg-white/95 rounded-full px-2.5 py-1 text-xs text-gray-800 shadow inline-flex items-center gap-1">
                          {uploading === 'video' ? <Loader2 size={13} className="animate-spin" /> : <Film size={13} />} {camp.video ? 'Değiştir' : 'Video yükle'}
                        </button>
                        {camp.video && <button type="button" onClick={() => set('campaign.video', null)} className="bg-white/95 rounded-full px-1.5 py-1 text-gray-700 shadow"><X size={13} /></button>}
                      </div>
                    )}
                  </div>
                  {[0, 1].map((i) => {
                    const src = images[i];
                    return (
                      <div key={i} style={{ borderRadius: 20, overflow: 'hidden', background: C.tile, position: 'relative' }}>
                        {src
                          ? <img src={src} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
                          : <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: C.ink3, fontSize: 12.5 }}>Kreatif {i + 1}</div>}
                        {editing && (
                          <div className="bt-noprint" style={{ position: 'absolute', right: 10, top: 10, display: 'flex', gap: 6 }}>
                            <button type="button" onClick={() => pickImage(i)} className="bg-white/95 rounded-full px-2.5 py-1 text-xs text-gray-800 shadow inline-flex items-center gap-1">
                              {uploading === i ? <Loader2 size={13} className="animate-spin" /> : <ImagePlus size={13} />} {src ? 'Değiştir' : 'Yükle'}
                            </button>
                            {src && <button type="button" onClick={() => removeImage(i)} className="bg-white/95 rounded-full px-1.5 py-1 text-gray-700 shadow"><X size={13} /></button>}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 12 }}>
                  {[['Gösterim', num(campImpr), C.brand], ['İzlenme', num(campViews), C.pink], ['Video tamamlanma', campRate != null ? pct(campRate) : '–', C.up]].map(([l, val, col]) => (
                    <div key={l} className="bm-tile white" style={{ justifyContent: 'space-between', padding: '14px 18px' }}>
                      <span className="bm-lbl">{l}</span>
                      <span className="bm-num" style={{ fontSize: 34, letterSpacing: '-.03em', color: col }}>{val}</span>
                    </div>
                  ))}
                </div>
                <div className="bm-tile" style={{ background: TINT.brand, padding: '14px 18px' }}>
                  <span className="bm-lbl">Kampanya özeti</span>
                  <div className="bm-txt" style={{ fontSize: 13.5, color: C.ink, marginTop: 4 }}>{campSummary ? <RichText text={campSummary} /> : <span style={{ color: C.ink3 }}>Kampanya özeti girilmedi.</span>}</div>
                </div>
              </div>

              {/* Sağ */}
              <div style={{ display: 'grid', gridTemplateRows: products.length ? '1fr auto' : '1fr', gap: 12, minHeight: 0 }}>
                {products.length > 0 && <div className="bm-tile">
                  <span className="bm-lbl">En çok satan ürünler</span>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', columnGap: 10, rowGap: 8, marginTop: 10 }}>
                    {products.map((p, i) => (
                      <div key={p.name + i} style={{ minWidth: 0 }}>
                        <div style={{ height: products.length <= 3 ? 176 : 68, borderRadius: 14, background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
                          {p.image
                            ? <img src={p.image} alt="" referrerPolicy="no-referrer" style={products.length <= 3 ? { width: '100%', height: '100%', objectFit: 'cover' } : { maxWidth: '88%', maxHeight: '88%', objectFit: 'contain' }} />
                            : <span className="bm-num" style={{ fontSize: 22, color: C.hair }}>{i + 1}</span>}
                        </div>
                        <div style={{ fontSize: 12, fontWeight: 600, marginTop: 6, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', letterSpacing: '-.01em' }} title={p.name}>{p.name}</div>
                        <div className="bm-cap" style={{ fontSize: 11 }}>{p.qty != null ? `${intFull(p.qty)} adet` : ''}</div>
                      </div>
                    ))}
                  </div>
                </div>}
                <div className="bm-tile">
                  <span className="bm-lbl">En çok ziyaret edilen sayfalar</span>
                  {pages.slice(0, pageCount).map((p, i) => (
                    <div key={p.path + i} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '7px 0', borderTop: i ? `1px solid ${C.hair}` : 'none', marginTop: i ? 0 : 6 }}>
                      <span style={{ fontSize: 13, fontWeight: 600, color: C.ink3, width: 14 }}>{i + 1}</span>
                      <div style={{ minWidth: 0, flex: 1 }}>
                        <div style={{ fontSize: 13.5, fontWeight: 600, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', letterSpacing: '-.01em' }}>{p.label}</div>
                        <div className="bm-cap" style={{ fontSize: 11, color: C.ink3, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{p.path}</div>
                      </div>
                      {pageViews(p.path) != null && <span style={{ fontSize: 13, fontWeight: 600, whiteSpace: 'nowrap' }}>{num(pageViews(p.path))}</span>}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </Slide>
        </Scaled>
        {editing && (
          <div className={panel}>
            <div className="md:col-span-2 font-semibold text-amber-900">Sayfa 2 — ayın kampanyası ve öne çıkanlar</div>
            <div>
              <label className={lbl}>Üst satır</label>
              <TextField editing value={camp.tagline} onChange={(x) => set('campaign.tagline', x)} placeholder="50. Yıla özel · YouTube · Programatik · 1–31 Ağustos" />
            </div>
            <div>
              <label className={lbl}>Kampanya adı (sayfa başlığı)</label>
              <TextField editing value={camp.title} onChange={(x) => set('campaign.title', x)} placeholder="Kampanya adı" />
            </div>
            <div className="md:col-span-2">
              <label className={lbl}>Kampanya özeti (**kalın** yazılabilir, boşsa otomatik) · kreatif ve videoyu yukarıdaki kutulardan yükleyin</label>
              <TextField editing multiline rows={3} value={camp.summary} onChange={(x) => set('campaign.summary', x)} placeholder={campSummary.replace(/\*\*/g, '') || 'Kampanyanın amacı, kanalları ve sonucu…'} />
            </div>
            <div className="md:col-span-2">
              <label className={lbl}>Video (YouTube linki ya da yukarıdan dosya yükleyin)</label>
              <TextField editing value={camp.video} onChange={(x) => set('campaign.video', x)} placeholder="https://www.youtube.com/watch?v=…" />
            </div>
            <div>
              <label className={lbl}>Başlık altı satır (boşsa en çok trafik getiren kanal)</label>
              <TextField editing value={mx.lead2} onChange={(x) => set('mix.lead2', x)} placeholder={autoLead2.replace(/\*\*/g, '')} />
            </div>
            <div>
              <label className={lbl}>Kampanya sayıları yalnız bu kampanyadan gelsin (adında geçen kelime)</label>
              <TextField editing value={camp.videoKeyword} onChange={(x) => set('campaign.videoKeyword', x)} placeholder="Boşsa ayın branding gösterim/izlenmesi" />
            </div>
            <div className="grid grid-cols-3 gap-2">
              {[['impressions', 'Gösterim'], ['views', 'İzlenme'], ['completion', 'Tamamlanma %']].map(([k, l]) => (
                <div key={k}><label className={lbl}>{l}</label>
                  <NumberField editing value={cs[k]} onChange={(x) => set(`campaign.stats.${k}`, x)} placeholder="oto" /></div>
              ))}
            </div>
            <div>
              <label className={lbl}>En çok trafik getiren kanal</label>
              <select className="w-full text-sm border border-amber-300 rounded px-2 py-1.5 bg-white" value={channel?.label || ''} onChange={(e) => set('highlights.channel', e.target.value)}>
                {channels.map((c) => <option key={c.label} value={c.label}>{c.label} — {intFull(c.sessions)}</option>)}
              </select>
            </div>
            <div className="md:col-span-2">
              <label className={lbl}>En çok satan ürünler (6, sırayla)</label>
              <div className="grid grid-cols-2 md:grid-cols-6 gap-1.5">
                {[0, 1, 2, 3, 4, 5].map((i) => (
                  <select key={i} className="text-xs border border-amber-300 rounded px-1 py-1 bg-white" value={productNames[i] || ''}
                    onChange={(e) => { const arr = [...productNames]; arr[i] = e.target.value; set('highlights.products', arr.filter(Boolean)); }}>
                    <option value="">—</option>
                    {productOpts.map((p) => <option key={p.name} value={p.name}>{p.name} ({p.qty})</option>)}
                  </select>
                ))}
              </div>
            </div>
            <div className="md:col-span-2">
              <label className={lbl}>En çok ziyaret edilen sayfalar (yol + görünen ad)</label>
              <div className="grid md:grid-cols-3 gap-2">
                {[0, 1, 2].map((i) => (
                  <div key={i} className="flex gap-1">
                    <select className="w-1/2 text-xs border border-amber-300 rounded px-1 py-1 bg-white" value={pages[i]?.path || ''}
                      onChange={(e) => {
                        const po = pageOpts.find((x) => x.path === e.target.value);
                        const arr = pages.map((x) => ({ ...x })); arr[i] = { path: po.path, label: pageLabel(po) };
                        set('highlights.pages', arr);
                      }}>
                      {pageOpts.map((p) => <option key={p.path} value={p.path}>{p.path} — {intFull(p.views)}</option>)}
                    </select>
                    <input className="w-1/2 text-xs border border-amber-300 rounded px-1 py-1" value={pages[i]?.label || ''}
                      onChange={(e) => { const arr = pages.map((x) => ({ ...x })); arr[i] = { ...arr[i], label: e.target.value }; set('highlights.pages', arr); }} />
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>

      {/* ── 03 · GELECEK AY ── */}
      <div className="bt-section">
        <Scaled>
          <Slide theme={theme} no="3 / 3" eyebrow={`${nextName} ${nextYear} · Plan`} title={mx.h3 || autoH3} lead={mx.lead3 || autoLead3}>
            <div style={{ display: 'grid', gridTemplateColumns: `repeat(${plan.length}, 1fr)`, gap: 12, height: 196 }}>
              {plan.map(([l, actual, target, f, color]) => {
                const ch = change(target, actual);
                const max = Math.max(actual || 0, target || 0) || 1;
                return (
                  <div key={l} className="bm-tile">
                    <span className="bm-lbl">{l}</span>
                    <div className="bm-num" style={{ fontSize: 36, marginTop: 10 }}>{target != null ? f(target) : '–'}</div>
                    <div style={{ marginTop: 6 }}>
                      {target != null && actual ? <Delta ch={ch} size={12} label={`${DATIVE[month - 1]} göre`} /> : <span className="bm-cap" style={{ color: C.ink3 }}>Hedef girilmemiş</span>}
                    </div>
                    <div style={{ marginTop: 'auto' }}>
                      {[[monthName, actual, '#c9c9ce'], [nextName, target, color]].map(([m, val, col]) => (
                        <div key={m} style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 6 }}>
                          <span className="bm-cap" style={{ width: 52, fontSize: 11 }}>{m}</span>
                          <div style={{ flex: 1, height: 6, background: 'rgba(0,0,0,0.06)', borderRadius: 3, overflow: 'hidden' }}>
                            <div style={{ width: `${((val || 0) / max) * 100}%`, height: '100%', background: col, borderRadius: 3 }} />
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                );
              })}
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1.3fr 1.3fr', gap: 12, marginTop: 12, height: 'calc(100% - 208px)' }}>
              <div className="bm-tile" style={{ background: TINT.amber }}>
                <span className="bm-lbl">Bütçe dağılımı</span>
                <div style={{ display: 'flex', alignItems: 'center', gap: 18, marginTop: 14 }}>
                  {(() => {
                    const r = 50; const c = 2 * Math.PI * r;
                    const pp = budgetTotal ? budgetPerf / budgetTotal : 0;
                    return (
                      <svg width="124" height="124" viewBox="0 0 124 124">
                        <circle cx="62" cy="62" r={r} fill="none" stroke={C.up} strokeWidth="13" />
                        <circle cx="62" cy="62" r={r} fill="none" stroke={C.brand} strokeWidth="13" strokeDasharray={`${c * pp} ${c}`} transform="rotate(-90 62 62)" />
                        <text x="62" y="58" textAnchor="middle" fontSize="11" fill={C.ink2}>Toplam</text>
                        <text x="62" y="77" textAnchor="middle" fontSize="18" fontWeight="600" fill={C.ink} letterSpacing="-0.5">{budgetTotal ? money(budgetTotal) : '–'}</text>
                      </svg>
                    );
                  })()}
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                    {[['Performans', budgetPerf, C.brand], ['Branding', budgetBrand, C.up]].map(([l, val, col]) => (
                      <div key={l}>
                        <div className="bm-cap" style={{ display: 'flex', alignItems: 'center', gap: 6 }}><i style={{ width: 8, height: 8, borderRadius: 4, background: col, display: 'inline-block' }} />{l}</div>
                        <div className="bm-num" style={{ fontSize: 18, letterSpacing: '-.02em', marginTop: 3 }}>{val ? moneyFull(val) : '–'}</div>
                      </div>
                    ))}
                  </div>
                </div>
                <div style={{ marginTop: 'auto', borderTop: '1px solid rgba(0,0,0,0.08)', paddingTop: 12 }}>
                  <div className="bm-cap">{monthName} harcaması</div>
                  <div style={{ display: 'flex', alignItems: 'baseline', gap: 10, marginTop: 3 }}>
                    <span className="bm-num" style={{ fontSize: 24, letterSpacing: '-.025em' }}>{money(v.cost)}</span>
                    {budgetTotal > 0 && <Delta ch={change(budgetTotal, v.cost)} label={`${nextName} bütçesi`} size={11.5} />}
                  </div>
                </div>
              </div>

              <div className="bm-tile">
                <span className="bm-lbl">Planlanan kampanyalar</span>
                {campaigns.length ? campaigns.slice(0, 6).map((c, i) => (
                  <div key={i} style={{ display: 'flex', gap: 12, alignItems: 'center', padding: '11px 0', borderTop: i ? `1px solid ${C.hair}` : 'none', marginTop: i ? 0 : 6 }}>
                    <span style={{ width: 24, height: 24, borderRadius: 12, background: i === 0 ? C.ink : '#fff', color: i === 0 ? '#fff' : C.ink, fontSize: 12, fontWeight: 600, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>{i + 1}</span>
                    <span style={{ fontSize: 15, fontWeight: i === 0 ? 600 : 500, letterSpacing: '-.014em' }}>{c}</span>
                  </div>
                )) : (
                  <div className="bm-txt" style={{ marginTop: 10, overflow: 'hidden' }}>
                    {nx.text ? <RichText text={nx.text} /> : <span style={{ color: C.ink3 }}>Kampanyalar henüz girilmedi.</span>}
                  </div>
                )}
              </div>

              <div className="bm-tile">
                <span className="bm-lbl">Aktif mecralar</span>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 7, marginTop: 12 }}>
                  {chips.slice(0, 10).map((ch) => <span key={ch} className="bm-chip" style={{ padding: '4px 11px', fontSize: 12 }}>{ch}</span>)}
                </div>
                {(a.platformSpend || []).length > 0 && (() => {
                  const ps = a.platformSpend.slice(0, 5);
                  const tot = a.platformSpend.reduce((x, r) => x + r.cost, 0) || 1;
                  return (
                    <div style={{ marginTop: 'auto', paddingTop: 12 }}>
                      <div className="bm-lbl" style={{ marginBottom: 2 }}>{monthName} harcamasının dağılımı</div>
                      {ps.map((r) => (
                        <div key={r.label} style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop: 5 }}>
                          <span style={{ width: 116, fontSize: 12, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{r.label}</span>
                          <div style={{ flex: 1, height: 6, background: 'rgba(0,0,0,0.06)', borderRadius: 3, overflow: 'hidden' }}>
                            <div style={{ width: `${(r.cost / ps[0].cost) * 100}%`, height: '100%', background: C.brand, borderRadius: 3 }} />
                          </div>
                          <span style={{ width: 36, textAlign: 'right', fontSize: 12, fontWeight: 600 }}>{pct((r.cost / tot) * 100)}</span>
                        </div>
                      ))}
                    </div>
                  );
                })()}
              </div>
            </div>
          </Slide>
        </Scaled>
        {editing && (
          <div className={panel}>
            <div className="md:col-span-2 font-semibold text-amber-900">Sayfa 3 — {nextName} planı</div>
            <div>
              <label className={lbl}>Başlık (boşsa otomatik)</label>
              <TextField editing value={mx.h3} onChange={(x) => set('mix.h3', x)} placeholder={autoH3} />
            </div>
            <div>
              <label className={lbl}>Alt satır (boşsa otomatik)</label>
              <TextField editing value={mx.lead3} onChange={(x) => set('mix.lead3', x)} placeholder={autoLead3.replace(/\*\*/g, '')} />
            </div>
            <div>
              <label className={lbl}>Planlanan kampanyalar (her satıra bir tane, ilki vurgulanır)</label>
              <TextField editing multiline rows={5} value={nx.campaigns} onChange={(x) => set('next.campaigns', x)} placeholder={'Ana kampanya\nİkinci kampanya'} />
            </div>
            <div>
              <label className={lbl}>Aktif mecralar (virgülle; boşsa bu ay harcama yapılanlar)</label>
              <TextField editing value={nx.channels} onChange={(x) => set('next.channels', x)} placeholder="Google Ads, Meta Ads, Pinterest, Programatik" />
              <label className={`${lbl} mt-3`}>Not (kampanya listesi boşsa gösterilir)</label>
              <TextField editing multiline rows={3} value={nx.text} onChange={(x) => set('next.text', x)} placeholder="Gelecek ayın odağı…" />
            </div>
            <div className="md:col-span-2 grid grid-cols-3 md:grid-cols-6 gap-2">
              {[['revenue', 'Hedef ciro'], ['sessions', 'Hedef trafik'], ['impressions', 'Hedef gösterim'], ['views', 'Hedef izlenme'], ['costPerformance', 'Performans bütçe'], ['costBranding', 'Branding bütçe']].map(([k, l]) => (
                <div key={k}><label className="block text-[11px] text-amber-900 mb-0.5">{l}</label>
                  <NumberField editing value={nx.targets?.[k]} onChange={(x) => set(`next.targets.${k}`, x)} placeholder={nt[k] != null ? `oto ${Math.round(nt[k])}` : 'girilmemiş'} /></div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
